// src/utils/adminAxios.js

import axios from "axios";
import { API_BASE_URL } from "../config/urls";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";

// Create a separate axios instance for admin API calls
const adminAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - Add token to every request and validate expiry
adminAxios.interceptors.request.use(
  (config) => {
    // Get the access token from localStorage
    const accessToken = localStorage.getItem("admin_access");

    if (accessToken) {
      try {
        // Decode and check if token is expired
        const decoded = jwtDecode(accessToken);
        const isExpired = dayjs.unix(decoded.exp).diff(dayjs()) <= 0;

        if (isExpired) {
          // Token expired, clear storage and redirect to login
          localStorage.removeItem("admin_access");
          localStorage.removeItem("admin_refresh");
          window.location.href = "/admin-login";
          return Promise.reject(new Error("Token expired"));
        }

        // Token is valid, add to headers
        config.headers.Authorization = `Bearer ${accessToken}`;
      } catch (error) {
        // Invalid token, clear storage and redirect to login
        localStorage.removeItem("admin_access");
        localStorage.removeItem("admin_refresh");
        window.location.href = "/admin-login";
        return Promise.reject(new Error("Invalid token"));
      }
    } else {
      // No token, redirect to login
      window.location.href = "/admin-login";
      return Promise.reject(new Error("No access token"));
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle authentication errors
adminAxios.interceptors.response.use(
  (response) => {
    // If request is successful, just return the response
    return response;
  },
  (error) => {
    // If we get a 401 Unauthorized response, logout
    if (error.response?.status === 401) {
      localStorage.removeItem("admin_access");
      localStorage.removeItem("admin_refresh");
      window.location.href = "/admin-login";
    }

    return Promise.reject(error);
  }
);

export default adminAxios;
